import { Conditional } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LogicAction, Condition } from 'src/Models/Logical/Logical';
import { Questions } from 'src/Models/Questions';
import { Surveys } from 'src/Models/Surveys';
import { ValidationRule } from 'src/Models/helpers/ValidationRules';
import { Generic } from 'src/app/shared/helpers/generic';

@Injectable({
    providedIn: 'root'
})
export class LogicalWizard {

    static logicalNextQuestion(logicActions: LogicAction[], response: FormGroup, survey: Surveys, form_response: FormGroup): string | number | any {
        let isSatisfied = false;
        let nextQuestion = null; // pergunta padrão, caso nenhuma condição seja satisfeita
        let propertiesResponse = form_response.get('properties').value
        let propertiesAudience = survey.propertiesAudienceOBJ;

        for (let i = 0; i < logicActions.length; i++) {
            const condition = logicActions[i].condition;
            const detail = logicActions[i].details;
            if (condition.op === 'always') {
                isSatisfied = true;
            }
            else {
                for (let j = 0; j < condition.vars.length; j++) {
                    const varType = condition.vars[j].type;
                    const varValue = condition.vars[j].value;
                    const op = condition.vars[j].op;
                    const internal_name = condition.vars[j].internal_name;
                    const value_option_response = this.getConditionalQuestionResponse(condition, form_response)
                    
                    //#region  ConsoleLogs
                    // console.log("condition.op: ", condition.op);
                    // console.log("varType: ", varType);
                    // console.log("varValue: ", varValue);
                    // console.log("variable: ", internal_name);
                    // console.log("response.value.value: ", response.value.value);
                    //#endregion

                    if (varType === 'option') {
                        
                        //Validadores lógicos
                        if (condition.op === "is_null" || condition.op === "null") {
                           const rules: ValidationRule = {
                               is_null: varValue === null || varValue === 'null' || varValue === 'true' || varValue === 1 || varValue === '1'
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }

                        if (condition.op === "is_not_null" || condition.op === "not_null") {
                           const rules: ValidationRule = {
                               is_not_null: varValue === null || varValue === 'null' || varValue === 'false' || varValue === 0 || varValue === '0'
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }


                        if (condition.op === "contains") {
                           const rules: ValidationRule = {
                               contains: varValue as string
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }
                        if (condition.op === "not_contains") {
                           const rules: ValidationRule = {
                               not_contains: varValue as string
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }

                        if ((condition.op === "equals_to") || (condition.op === "equal")
                           || (condition.op === "equals") || (condition.op === "eq")) {
                           const rules: ValidationRule = {
                               equals_to: varValue as string
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }

                        if ((condition.op === "is_not_equals_to") || (condition.op === "not_equals_to") || (condition.op === "not_equal")
                           || (condition.op === "not_equals") || (condition.op === "neq")) {
                           const rules: ValidationRule = {
                               is_not_equals_to: varValue as string
                           };

                           const isValid = Generic.validateProperty(value_option_response.value, rules);

                           if (isValid) {
                               isSatisfied = true;
                               break;
                           }
                        }

                        if (condition.op === "less_or_equal_than") {
                            const rules: ValidationRule = {
                                less_or_equal_than: varValue as number
                            };

                            const isValid = Generic.validateProperty(value_option_response.value, rules);

                            if (isValid) {
                                isSatisfied = true;
                                break;
                            }
                        }
                        if (condition.op === "greater_or_equal_than") {
                            const rules: ValidationRule = {
                                greater_or_equal_than: varValue as number
                            };

                            const isValid = Generic.validateProperty(value_option_response.value, rules);

                            if (isValid) {
                                isSatisfied = true;
                                break;
                            }
                        }

                        if (response != null) {
                            // verificando se o usuário escolheu uma opção específica em uma pergunta
                            if (varValue == response.value.value) {
                                isSatisfied = true;
                                break;
                            }
                        }
                    } else if (varType === 'custom_field') {
                        if (propertiesResponse !== null && propertiesAudience !== null) {
                            // Verificar o valor da variavel
                            const id_property_selected = propertiesAudience.filter(x => x.internal_name === internal_name)[0].id_property
                            const customField = JSON.parse(propertiesResponse).filter(x => x.id_property === id_property_selected);
                            const customFieldValue = customField.length > 0 ? customField[0].value : null

                            const rules: ValidationRule = {
                                is_null: op == "null",
                                is_not_null: op == "notnull",
                            };

                            const isValid = Generic.validateProperty(customFieldValue, rules);
                            if (isValid) {
                                isSatisfied = true;
                                break;
                            }
                        }
                    }
                }
            }
            if (isSatisfied) {
                const to = logicActions[i].details.to;
                if (to.type === 'question' || to.type === 'redirect') {
                    nextQuestion = to.value;
                } else if (to.type === 'goodbye') {
                    nextQuestion = 'goodbye';
                }
                break;
            }
        }
        if (!isSatisfied) nextQuestion = 'next';
        return nextQuestion;
    }

    private static getConditionalQuestionResponse(condition: Condition, form_response: FormGroup) {
        if (condition.vars.find(x => x.type === 'question')) {
            let id_question = condition.vars.find(x => x.type === 'question').value
            return form_response.get('responses').value.data.find(x => x.fk_question == id_question)
        }
        return null
    }

    static getNextQuestionLogical(questions: Questions[], valueDestination: string | number, i): Questions | undefined {
        if (valueDestination === 'goodbye') return null
        else if (valueDestination == 'next') return questions[i + 1];
        else return questions.find((question: Questions) => question.id_question === (Number(valueDestination)));
    }

    static setNextStepWizard(destination, wizard, lengthQuestions, goToStep) {
        if (destination == 'goodbye')
            wizard.goToStep(lengthQuestions);
        else if (destination == 'next')
            wizard.goToNextStep();
        else
            wizard.goToStep(goToStep);
    }
}